import type { PasteTextareaTranslations } from '../paste-textarea';

const en: PasteTextareaTranslations = {
  HEADER_TITLE: 'Paste Your Content',
  HEADER_SUBTITLE: 'Paste your content and let AI help you',
  TEXTAREA_LABEL: 'Your content',
  TEXTAREA_PLACEHOLDER: 'Paste your content here...',
  SUBMIT_BUTTON: 'Submit',
  SUBMITTING_BUTTON: 'Processing...',
  CANCEL_BUTTON: 'Clear',
  CHARACTERS: 'characters',
  WARNING_NEAR_LIMIT: '{remaining} characters remaining',
  ERROR_TOO_LONG: '{excess} characters over the limit',
  ERROR_REQUIRED: 'This field is required',
};

export default en;
